import React from 'react'

export interface HighlightedBoxProps {}

export const HighlightedBox: React.FunctionComponent<HighlightedBoxProps> = ({
	children,
}) => {
	return <div className="highlightedBox">{children}</div>
}
